/*
 * Aeroraise 落地页页面级交互 — 服务于 sections/aeroraise-landing.liquid
 * 购买区（图集 / 变体 / 加购 / Buy Now / 尺码表）由公共组件 assets/nx-lp-shop.js 负责，本文件只管：
 *   进页滚动归零、悬浮购买栏（显隐 + 跟随购买区变体换价格 / 图片 + 选齐尺码后直接触发购买区 Buy Now）。
 * 配置全部走 data-* 属性，不含 Liquid 插值，可作为静态资源长期缓存。
 */
((doc) => {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  if (!window.location.hash) {
    window.scrollTo(0, 0);
  }
  window.addEventListener('pageshow', () => {
    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }
  });

  /* ---------------------------------------------------------- 吸底/悬浮快购栏 */
  const bindStickybar = (root) => {
    const bar = root.querySelector('[data-arl-stickybar]');
    if (!bar) return;

    const actionBtn = bar.querySelector('[data-arl-stickybar-atc]');
    const priceEl = bar.querySelector('[data-arl-stickybar-price]');
    const imageEl = bar.querySelector('[data-arl-stickybar-img]');
    const shop = root.querySelector('[data-lps-product]');
    const hero = root.querySelector('.arl-hero');
    const shopLayout = shop?.querySelector('.nx-lps__layout') || shop;
    const footer = doc.querySelector('.site-nx-footer') || doc.querySelector('footer') || doc.querySelector('.site-footer');
    const buyNowOf = () => shop?.querySelector('[data-lps-buynow]');

    const updateChatPosition = (visible) => {
      const isDesktop = window.innerWidth >= 768;
      const chat = doc.querySelector('shopify-chat');
      const wrapper = chat?.shadowRoot?.querySelector('#shopify-element-wrapper') || chat?.shadowRoot?.host;
      const nudge = chat?.shadowRoot?.querySelector('.activator-nudge');
      if (nudge) {
        nudge.style.setProperty('transition', 'bottom 0.3s cubic-bezier(0.16, 1, 0.3, 1)', 'important');
      }
      if (wrapper) {
        if (visible) {
          const offset = isDesktop ? '160px' : 'calc(68px + env(safe-area-inset-bottom, 0px))';
          wrapper.style.setProperty('--shopify-chat-activator-offset', offset);
        } else {
          wrapper.style.removeProperty('--shopify-chat-activator-offset');
        }
      }
      doc.body.classList.toggle('has-arl-stickybar', visible);
    };

    const checkVisibility = () => {
      // 1. hero 部分：若 hero 底部还在视口上方可见区内，则视为在 hero 部分
      const heroRect = hero?.getBoundingClientRect();
      const inHero = hero ? (heroRect.bottom > 60) : false;

      // 2. 购买区图集 + 购买栏：处于视口中时隐藏
      const shopRect = shopLayout?.getBoundingClientRect();
      const inShop = shopLayout ? (shopRect.top < window.innerHeight && shopRect.bottom > 0) : false;

      // 3. footer 部分：若 footer 顶部进入视口
      const footerRect = footer?.getBoundingClientRect();
      const inFooter = footer ? (footerRect.top < window.innerHeight) : false;

      const shouldShow = !inHero && !inShop && !inFooter;
      bar.classList.toggle('is-visible', shouldShow);
      updateChatPosition(shouldShow);
    };

    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility, { passive: true });
    checkVisibility();

    let chatRetries = 0;
    const chatPoll = setInterval(() => {
      chatRetries += 1;
      const chat = doc.querySelector('shopify-chat');
      if (chat?.shadowRoot?.querySelector('.activator-nudge') || chatRetries > 20) {
        clearInterval(chatPoll);
        checkVisibility();
      }
    }, 500);

    // 购买区变体联动后同步：选齐尺码才换价格 / 图片；按钮转圈跟随购买区 Buy Now（失败或从结账页返回时一起解除）
    shop?.addEventListener('nx-lps:variant', ({ detail }) => {
      actionBtn?.classList.toggle('is-loading', Boolean(buyNowOf()?.classList.contains('is-loading')));
      const { variant, complete } = detail ?? {};
      if (!complete || !variant) return;
      if (priceEl) priceEl.innerHTML = variant.price ?? '';
      if (imageEl && variant.featured_image) imageEl.src = variant.featured_image;
    });

    // 悬浮栏按钮：未选尺码 / 当前组合不可买时走原生 <a> 锚点跳到购买区（与 hero「Shop Now」完全一样）；
    // 选齐可买后直接触发购买区的 Buy Now 结算
    actionBtn?.addEventListener('click', (event) => {
      const sizeSelect = shop?.querySelector('select[data-lps-option]');
      const hasSize = sizeSelect ? sizeSelect.value !== '' : true;
      const variantId = shop?.querySelector('[data-lps-variant-id]')?.value;
      const buyNow = buyNowOf();
      if (!hasSize || !variantId || !buyNow || buyNow.disabled) return;

      event.preventDefault();
      buyNow.click();
      actionBtn.classList.toggle('is-loading', buyNow.classList.contains('is-loading'));
    });
  };

  /* -------------------------------------------------------------- 启动 */
  const init = (root) => {
    if (root.dataset.arlReady) return;
    root.dataset.arlReady = 'true';
    bindStickybar(root);
  };
  const boot = () => doc.querySelectorAll('[data-arl-root]').forEach(init);

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(document);
